import React from 'react';

export default class PrintingActions extends React.Component {
    constructor(props) {
        super(props);

        const { checkPrints } = props;
        this.state = {
            reprintRangeFrom: checkPrints.length ? checkPrints[0].checkNumber : '',
            reprintRangeTo: checkPrints.length ? checkPrints[checkPrints.length - 1].checkNumber : '',
            showReprintDropdown: false
        };
    }

    onChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    onBlurPrintRange(min, max, e) {
        if (e.target.value < min)
            this.setState({ [e.target.name]: min });
        else if (e.target.value > max)
            this.setState({ [e.target.name]: max });
    }

    render() {
        const { checkPrints: checks } = this.props;
        return (
            <tr className="no-background-row">
                <td></td>
                <td></td>
                <td className="flex-center reprint-column">
                    <div className="custom-dropdown">
                        <button className="btn btn-flat reprint-btn" onClick={() => this.setState({ showReprintDropdown: !this.state.showReprintDropdown })}>
                            <p className="medium-text"><i className="icon-printer icon-left"></i>Reprint</p>
                            <i className={`"icon icon-right ion-android-arrow-drop${this.state.showReprintDropdown ? "up" : "down"}`}></i>
                        </button>
                        {this.state.showReprintDropdown && <div className="custom-dropdown-box">
                            <div className="custom-dropdown-option">
                                <div className="flex-justify">
                                    <p className="medium-text">All</p>
                                </div>
                                <div className="custom-dropdown-extension">
                                    <button className="btn btn-flat btn-flat-primary btn-xs btn-fullWidth btn-flat-primary-background"
                                        onClick={this.props.reprint.bind(this, checks.map(ck => ck.printJobId))}>
                                        <i className="icon icon-printer icon-left"></i>Print
                                            </button>
                                </div>
                            </div>
                            <div className="custom-dropdown-option">
                                <div className="flex-justify">
                                    <p className="medium-text">Range</p>
                                </div>
                                <div className="custom-dropdown-extension">
                                    <input type="text" name="reprintRangeFrom" value={this.state.reprintRangeFrom}
                                        onChange={this.onChange.bind(this)}
                                        onBlur={this.onBlurPrintRange.bind(this, checks[0].checkNumber, this.state.reprintRangeTo)} />
                                     <input type="text" name="reprintRangeTo" value={this.state.reprintRangeTo}
                                        onChange={this.onChange.bind(this)}
                                        onBlur={this.onBlurPrintRange.bind(this, this.state.reprintRangeFrom, checks[checks.length -1].checkNumber)} />
                                    <button className="btn btn-flat btn-flat-primary btn-xs btn-flat-primary-background"
                                        disabled={!this.state.reprintRangeFrom || !this.state.reprintRangeTo 
                                            || (this.state.reprintRangeFrom > this.state.reprintRangeTo) 
                                            || (this.state.reprintRangeFrom < checks[0].checkNumber)
                                            || (this.state.reprintRangeTo > checks[checks.length - 1].checkNumber)}
                                        onClick={this.props.reprint.bind(this, checks
                                            .filter(ck => ck.checkNumber >= this.state.reprintRangeFrom && ck.checkNumber <= this.state.reprintRangeTo)
                                            .map(ck => ck.printJobId))}>
                                        <i className="icon icon-printer icon-left"></i>Print
                                            </button>
                                </div>
                            </div>
                        </div>}
                    </div>
                </td>
                <td>
                    <div className="custom-check-container">
                        <input type="checkbox" id="printed-all" className="custom-check" checked={this.props.printsConfirmed.length === checks.length}
                            onChange={e => {
                                this.props.markPrintsConfirmed(e.target.checked ? checks.map(ck => ck.checkNumber) : []);
                                if(e.target.checked) {
                                    this.props.markPrintsCancelled([]);
                                }
                            }} 
                        />
                        <label htmlFor="printed-all" className="secondary-text">Select All</label>
                    </div>
                </td>
                <td>
                <div className="custom-check-container">
                        <input type="checkbox" id="cancel-print-all" className="custom-check" checked={this.props.printsCancelled.length === checks.length}
                            onChange={e => {
                                this.props.markPrintsCancelled(e.target.checked ? checks.map(ck => ck.checkNumber) : []);
                                if(e.target.checked) {
                                    this.props.markPrintsConfirmed([]);
                                }
                            }} 
                        />
                        <label htmlFor="cancel-print-all" className="secondary-text">Select All</label>
                    </div>
                </td>
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/printingComponents/PrintingActions.jsx